"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ProductConfiguration_1 = require("../models/ProductConfiguration");
var mockProductConfiguration = __assign(__assign({}, ProductConfiguration_1.makeEmptyProductConfiguration()), { plan: 'mock-plan', revision: 'mock-revision', reportName: 'mock-report-name', inspectionRequired: true, id: 10, code: 'mock-code', name: 'mock-name' });
exports.default = mockProductConfiguration;
//# sourceMappingURL=mockProductConfiguration.js.map